export default "__VITE_ASSET__oD9LevTQ__"